import script from "./OHLCExplorerTab.vue?vue&type=script&setup=true&lang=js"
export * from "./OHLCExplorerTab.vue?vue&type=script&setup=true&lang=js"

import "./OHLCExplorerTab.vue?vue&type=style&index=0&id=a75a1b1e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a75a1b1e"]])

export default __exports__